import { ReactNode, useRef } from 'react';

import { QueryFunction } from '@tanstack/query-core/src/types';
import { QueryCache, QueryClient, QueryClientProvider as ReactQueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useSnackbar } from 'notistack';

import { queryFnFactory } from '../../services/utilities';

export interface IQueryClientProviderProps {
  children: ReactNode;
}

export default function QueryClientProvider({ children }: IQueryClientProviderProps) {
  const { enqueueSnackbar } = useSnackbar();

  const { current: queryClient } = useRef<QueryClient>(
    new QueryClient({
      defaultOptions: {
        queries: {
          queryFn: queryFnFactory() as QueryFunction,
          // suspense: true,
        },
      },
      queryCache: new QueryCache({
        onError: (error, query) => {
          // 🎉 only show error toasts if we already have data in the cache
          // which indicates a failed background update
          if (query.state.data !== undefined) {
            enqueueSnackbar(`Something went wrong: ${(error as Error).message}`);
          }
        },
      }),
    }),
  );

  return (
    <ReactQueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools position="bottom-right" />
    </ReactQueryClientProvider>
  );
}
